import gql from 'graphql-tag';

const multiUnitListWrapperFragments = {
    Listing: gql`
        fragment MultiUnitListWrapperListing on Listing {
            listingNamespace
            listingNumber
        }
    `
};

export default multiUnitListWrapperFragments;
